import { Box } from "@mui/material";
import { useCallback, useState } from "react";
import useColors from "../../../../../../../../api/hooks/useColors";
import RegularCommentBlock from "./RegularCommentBlock";
import ResolvedComment from "./ResolvedComment";

export default function Comment({ log }) {
  const colors = useColors();
  const [isHovered, setIsHovered] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const handleMouseEnter = useCallback(() => setIsHovered(true), []);
  const handleMouseLeave = useCallback(() => setIsHovered(false), []);

  return (
    <Box paddingY="12px">
      <Box
        display="flex"
        flexDirection="column"
        gap={1}
        borderRadius="8px"
        padding="8px"
        border={`1px solid ${colors.enabled_stroke_20}`}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        data-hovered={isHovered}
        sx={{
          backgroundColor:
            isHovered &&
            (!log.resolved_by_user_id ||
              (log.resolved_by_user_id && isExpanded))
              ? colors.text_area_outlined_hovered_bg
              : "transparent",
        }}
      >
        {log.resolved_by_user_id ? (
          <ResolvedComment
            log={log}
            isHovered={isHovered}
            isExpanded={isExpanded}
            setIsExpanded={setIsExpanded}
          />
        ) : (
          <RegularCommentBlock log={log} isHovered={isHovered} />
        )}
      </Box>
    </Box>
  );
}
